module.exports = __webpack_public_path__ + "img/crosshatch.c4f557f0.jpg";